module.exports = __webpack_public_path__ + "media/images/summa-a6dfca27e8ff12c237db511c39544b6b.jpg";